export const COUNTRY_OF_OFFER_TO_DEFAULT_TIMEZONE: Record<string, string> = {
  Australia: 'Australia/Sydney',
  Austria: 'Europe/Vienna',
  Belgium: 'Europe/Brussels',
  Canada: 'America/Toronto',
  China: 'Asia/Shanghai',
  Denmark: 'Europe/Copenhagen',
  Finland: 'Europe/Helsinki',
  France: 'Europe/Paris',
  Germany: 'Europe/Berlin',
  'Hong Kong': 'Asia/Hong_Kong',
  India: 'Asia/Kolkata',
  Ireland: 'Europe/Dublin',
  Israel: 'Asia/Tel_Aviv',
  Italy: 'Europe/Rome',
  Japan: 'Asia/Tokyo',
  Jersey: 'Europe/Jersey',
  Luxembourg: 'Europe/Luxembourg',
  Malta: 'Europe/Malta',
  Monaco: 'Europe/Monaco',
  Netherlands: 'Europe/Amsterdam',
  Norway: 'Europe/Oslo',
  Portugal: 'Europe/Lisbon',
  'Russian Federation': 'Europe/Moscow',
  Singapore: 'Asia/Singapore',
  'South Africa': 'Africa/Johannesburg',
  Spain: 'Europe/Madrid',
  Sweden: 'Europe/Stockholm',
  Switzerland: 'Europe/Zurich',
  UK: 'Europe/London',
  'United Kingdom': 'Europe/London',
  'United Arab Emirates': 'Asia/Dubai',
  'United States of America': 'America/New_York',
};

export const COUNTRY_OF_OFFER_ALL_TIMEZONES: Record<string, string[]> = {
  Australia: [
    'Antarctica/Macquarie',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Broken_Hill',
    'Australia/Darwin',
    'Australia/Eucla',
    'Australia/Hobart',
    'Australia/Lindeman',
    'Australia/Lord_Howe',
    'Australia/Melbourne',
    '	Australia/Perth',
    'Australia/Sydney',
  ],
  Austria: ['Europe/Vienna'],
  Belgium: ['Europe/Brussels'],
  Canada: [
    'America/Cambridge_Bay',
    'America/Dawson',
    'America/Dawson_Creek',
    'America/Edmonton',
    'America/Fort_Nelson',
    'America/Glace_Bay',
    'America/Goose_Bay',
    'America/Halifax',
    'America/Inuvik',
    'America/Iqaluit',
    'America/Moncton',
    'America/Rankin_Inlet',
    'America/Regina',
    'America/Resolute',
    'America/St_Johns',
    'America/Swift_Current',
    'America/Toronto',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Winnipeg',
  ],
  China: ['Asia/Shanghai', 'Asia/Urumqi'],
  Denmark: ['Europe/Copenhagen'],
  Finland: ['Europe/Helsinki'],
  France: ['Europe/Paris'],
  Germany: ['Europe/Berlin'],
  'Hong Kong': ['Asia/Hong_Kong'],
  India: ['Asia/Kolkata'],
  Ireland: ['Europe/Dublin'],
  Israel: ['Asia/Tel_Aviv'],
  Italy: ['Europe/Rome'],
  Japan: ['Asia/Tokyo'],
  Jersey: ['Europe/Jersey'],
  Luxembourg: ['Europe/Luxembourg'],
  Malta: ['Europe/Malta'],
  Monaco: ['Europe/Monaco'],
  Netherlands: ['Europe/Amsterdam'],
  Norway: ['Europe/Oslo'],
  Portugal: ['Europe/Lisbon'],
  'Russian Federation': [
    'Asia/Anadyr',
    'Asia/Barnaul',
    'Asia/Chita',
    'Asia/Irkutsk',
    'Asia/Kamchatka',
    'Asia/Khandyga',
    'Asia/Krasnoyarsk',
    'Asia/Magadan',
    'Asia/Novokuznetsk',
    'Asia/Novosibirsk',
    'Asia/Omsk',
    'Asia/Sakhalin',
    'Asia/Srednekolymsk',
    'Asia/Tomsk',
    'Asia/Ust-Nera',
    'Asia/Vladivostok',
    'Asia/Yakutsk',
    'Asia/Yekaterinburg',
    'Europe/Astrakhan',
    'Europe/Kaliningrad',
    'Europe/Kirov',
    'Europe/Moscow',
    'Europe/Samara',
    'Europe/Saratov',
    'Europe/Ulyanovsk',
    'Europe/Volgograd',
  ],
  Singapore: ['Asia/Singapore'],
  'South Africa': ['Africa/Johannesburg'],
  Spain: ['Europe/Madrid'],
  Sweden: ['Europe/Stockholm'],
  Switzerland: ['Europe/Zurich'],
  UK: ['Europe/London'],
  'United Kingdom': ['Europe/London'],
  'United Arab Emirates': ['Asia/Dubai'],
  'United States of America': [
    'America/Adak',
    'America/Anchorage',
    'America/Boise',
    'America/Chicago',
    'America/Denver',
    'America/Detroit',
    'America/Indiana/Indianapolis',
    'America/Indiana/Knox',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Tell_City',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Juneau',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Los_Angeles',
    'America/Menominee',
    'America/Metlakatla',
    'America/New_York',
    'America/Nome',
    'America/North_Dakota/Beulah',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/Phoenix',
    'America/Sitka',
    'America/Yakutat',
    'Pacific/Honolulu',
  ],
};

function getTimezoneDisplayName(timezone: string): string {
  const timezoneParts = timezone.split('/');
  return timezoneParts[timezoneParts.length - 1].replace('_', ' ');
}

export function getTimezonesByCountry(
  country: string
): { id: string; displayValue: string }[] {
  return COUNTRY_OF_OFFER_ALL_TIMEZONES[country].map((timezone) => ({
    id: timezone,
    displayValue: getTimezoneDisplayName(timezone),
  }));
}
